<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>System Messages</h2>
  <mat-dialog-content class="dialog-content">
    <div>
      <form [formGroup]="form">
        <mat-form-field matTooltip="Business Unit (optional)">
          <mat-label i18n="@@type.SystemMessage.businessUnit">BusinessUnit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit"
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="item.businessUnit"
              (ngModelChange)="businessUnitChanged($event)" #businessUnit
              placeholder="All Business Units" [compareWith]="businessUnitCompare">
            <mat-option value="All Business Units">All Business Units</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Message Text" class="textarea-full-wide">
          <mat-label i18n="@@type.SystemMessage.message">Message</mat-label>
          <textarea matInput formControlName="message" class="field-full-width"
            id="message" (ngModelChange)="messageChanging($event)"
            [(ngModel)]="item.message" (ngModelChange)="messageChanged($event)"
            #message placeholder="Message" required></textarea>
        </mat-form-field>

        <mat-form-field matTooltip="Expiry Date (optional)">
          <mat-label i18n="@@type.SystemMessage.expiryDate">Expiry Date</mat-label>
          <input matInput formControlName="expiryDate" id="expiryDate" type="datetime"
            (ngModelChange)="expiryDateChanging($event)" [(ngModel)]="item.expiryDate"
            (ngModelChange)="expiryDateChanged($event)" #expiryDate [matDatetimepicker]="expiryDateDatePicker"
            placeholder="Expiry Date">
          <mat-datetimepicker-toggle matSuffix [for]="expiryDateDatePicker"></mat-datetimepicker-toggle>
          <mat-datetimepicker #expiryDateDatePicker type="datetime" timeInterval="1" color="primary"></mat-datetimepicker>
        </mat-form-field>

        <button class="action-button" mat-raised-button color="primary" (click)="addSystemMessage()"
        i18n="@@actions.add" disabled="{{form.invalid}}">Add</button>
      </form>
    </div>
    <app-system-message-search [mode]="'popup'"></app-system-message-search>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="closeDialog()">Ok</button>
  </mat-dialog-actions>
</div>
